import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=3cf7fdfc&scoped=true&"
import script from "./privacy.vue?vue&type=script&lang=js&"
export * from "./privacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf7fdfc",
  null
  
)

export default component.exports